import { defineNuxtPlugin } from '#app'
// import {useProductStore} from "~/modules/common/stores/products";
import {useStorageStore} from "~/store/storage";
import {useContentStore} from "~/store/content";
// import { useTenantStore } from "~/store/tenants";

export default defineNuxtPlugin(async (nuxtApp) => {

    const storageStore = useStorageStore();
    await storageStore.initialize();

    const contentStore = useContentStore();
    await contentStore.initialize();

})
